export default "__VITE_ASSET__fdfc07c0__"